<template>
  <vlt-modal class="modal" :can-cancel="canCancel" :ok-text="okText" :title="title" :visible="visible" :large="large" :no-footer="noFooter" @close="close" @confirm="confirm">
    <slot></slot>
  </vlt-modal>
</template>
<script>
import { VltModal } from '@vonagevolta/vue';

export default {
    name: 'CdModal',

    components: {
        VltModal,
    },

    props: {
        title: {
            type: String,
            default: '',
        },
        visible: {
            type: Boolean,
            default: false,
        },
        large: {
            type: Boolean,
            default: false,
        },
        noFooter: {
            type: Boolean,
            default: false,
        },
        canCancel: {
            type: Boolean,
            default: true,
        },
      okText: {
        type: String,
        required: false,
      },
    },

    methods: {
        close() {
            this.$emit('close');
        },
      confirm() {
        this.$emit('confirm');
      },
    }
}
</script>
<style scoped>
  .Vlt-modal_visible {
    background: unset;
  }
  .modal >>> .Vlt-modal__panel {
    padding: 24px;
  }
</style>